module.exports = __webpack_public_path__ + "img/en.c4cd6642.svg";